import React, { Suspense, lazy } from 'react';
import CookieBanner from '../cookie/CookieBanner.jsx';
import { useFeatureFlags } from '@/context/FeatureFlagContext.jsx';

const Footer = lazy(() => import('./Footer'));
const CookiePreferencesDialog = lazy(() => import('../cookie/CookiePreferencesDialog.jsx'));

function CookieControls({
    isCookieBannerVisible,
    onOpenPreferences,
    isCookiePreferencesOpen,
    isSelectivePublic = false,
    onClosePreferences,
}) {
    const { isFlagActive, isLoading: areFeatureFlagsLoading } = useFeatureFlags();
    const isNewsletterEnabled =
        !areFeatureFlagsLoading && isFlagActive('newsletter_footer_enabled');

    return (
        <>
            <CookieBanner visible={isCookieBannerVisible} onManagePreferences={onOpenPreferences} />
            <Suspense fallback={null}>
                <Footer
                    isNewsletterEnabled={isNewsletterEnabled}
                    isSelectivePublic={isSelectivePublic}
                    onCookieSettingsClick={onOpenPreferences}
                />
            </Suspense>
            <Suspense fallback={null}>
                {isCookiePreferencesOpen ? (
                    <CookiePreferencesDialog open={isCookiePreferencesOpen} onClose={onClosePreferences} />
                ) : null}
            </Suspense>
        </>
    );
}

export default CookieControls;
